// extracted by mini-css-extract-plugin
module.exports = {"overlay":"cg-z","bodyOpen":"dg-z","content":"eg-z","header":"fg-z","close":"gg-z","closeNoHeading":"hg-z"};